import React from 'react';
import { Link } from 'react-router-dom';
import './Crew.css';
import PageHero from './PageHero';

const crewMembers = [
  {
    name: 'Shawn De Pedro',
    role: 'Founder & full-stack developer',
    grade: '11th Grade',
    skills: [
      'Founder',
      'React',
      'Node.js',
      'UI/UX Design',
      'Frontend Development',
      'JavaScript',
      'CSS',
      'HTML',
      'PostgreSQL',
      'Express.js',
      'Axios',
    ],
    route: '/crew/shawn',
  },
  {
    name: 'Kaeden Martinez',
    role: 'Social & content lead',
    grade: '11th Grade',
    skills: [
      'Social Media Marketing',
      'Content Creation',
      'Advertising',
      'Video Editing',
      'Audio Editing',
      'Effect Creation',
    ],
    route: '/crew/kaeden',
  },
  {
    name: 'Alec Wyrick',
    role: 'Photography & videography',
    grade: '11th Grade',
    skills: [
      'Photography',
      'Videography',
      'Lighting',
      'Photo Editing',
      'Video Editing',
      'Color Grading',
      'Event Coverage',
    ],
    route: '/crew/alec',
  },
];

const COLLABORATION = [
  {
    title: 'Unified vision',
    body: 'One team, one goal — making your business work online.',
  },
  {
    title: 'Seamless integration',
    body: 'Site, brand, and content built together so the pieces match.',
  },
  {
    title: 'Full-service',
    body: 'Design through development through marketing, under one roof.',
  },
];

const Crew = () => (
  <>
    <PageHero
      eyebrow="Studio / Crew"
      title="The people who actually build it."
      lede="Three students from Corning-Painted Post High School, each running a discipline. No account managers, no handoffs — you talk to the person doing the work."
      meta={[`${crewMembers.length} members`, 'Development · Content · Camera']}
    >
      <Link to="/contact?reason=quote" className="btn btn--primary">
        Start a project <span className="btn-arrow">→</span>
      </Link>
    </PageHero>

    <main className="main-content" id="main">
      <section className="section crew-section">
        <div className="container">
          <ul className="crew-list" data-stagger="0.09">
            {crewMembers.map((member, idx) => (
              <li className="crew-card reveal reveal-up" key={member.route}>
                <Link to={member.route} className="crew-card-link">
                  <span className="crew-index" aria-hidden="true">
                    {String(idx + 1).padStart(2, '0')}
                  </span>

                  <span className="crew-avatar" aria-hidden="true">
                    {member.name
                      .split(' ')
                      .map((part) => part[0])
                      .slice(0, 2)
                      .join('')}
                  </span>

                  <span className="crew-body">
                    <span className="crew-role">{member.role}</span>
                    <span className="crew-name">{member.name}</span>
                    <span className="crew-grade">{member.grade}</span>

                    <span className="crew-skills">
                      {member.skills.map((skill) => (
                        <span className="crew-skill" key={skill}>
                          {skill}
                        </span>
                      ))}
                    </span>

                    <span className="crew-cta">
                      Learn more about {member.name.split(' ')[0]}{' '}
                      <span className="btn-arrow">→</span>
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section section--alt crew-collab">
        <div className="container">
          <div className="section-head section-head--center">
            <p className="eyebrow">Working together</p>
            <h2 className="section-title reveal reveal-up">Ready to work with the team?</h2>
            <p className="section-lede reveal reveal-up" style={{ '--reveal-delay': '0.08s' }}>
              Our range means one group can carry a project from first sketch to
              launch — and keep it consistent the whole way.
            </p>
          </div>

          <ul className="collab-grid" data-stagger="0.07">
            {COLLABORATION.map((item, idx) => (
              <li className="collab-item reveal reveal-up" key={item.title}>
                <span className="collab-index">{String(idx + 1).padStart(2, '0')}</span>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>

          <div className="crew-collab-cta reveal reveal-up">
            <Link to="/contact?reason=quote" className="btn btn--primary btn--lg">
              Start your project discussion <span className="btn-arrow">→</span>
            </Link>
            <p className="crew-collab-note">
              Free consultation · Meet the team · Talk through what you need
            </p>
          </div>
        </div>
      </section>
    </main>
  </>
);

export default Crew;
